import { addMinutes, differenceInYears, isValid } from 'date-fns';
import { zonedTimeToUtc } from 'date-fns-tz';

/**
 * Model to hold User data that was fetched from the core database
 */
export class UserCore {
    public id: string;
    public username: string;
    public firstName: string;
    public lastName: string;
    public email: string;
    public profilePhoto: string;
    public gender: string;
    public birthday: Date;
    public isFloProMember: boolean;
    public zipCode: string;

    get age(): number {
        if (this.birthday) {
            return differenceInYears(new Date(), this.birthday);
        }

        return null;
    }

    get displayName(): string {
        return (`${this.firstName || ''} ${this.lastName || ''}`).trim();
    }

    public clone(): UserCore {
        const clone: UserCore = new UserCore();
        clone.id = this.id;
        clone.username = this.username;
        clone.firstName = this.firstName;
        clone.lastName = this.lastName;
        clone.email = this.email;
        clone.profilePhoto = this.profilePhoto;
        clone.gender = this.gender;
        clone.birthday = this.birthday;
        clone.isFloProMember = this.isFloProMember;
        clone.zipCode = this.zipCode;
        return clone;
    }

    /**
     * Deserialize from json
     */
    public deserialize(json: Object): UserCore {
        const data: Object = json['data'] || json;

        this.id = data['id'];
        this.username = data['username'];
        this.firstName = data['first_name'] || '';
        this.lastName = data['last_name'] || '';
        this.email = data['email'];
        this.profilePhoto = data['profile_picture_url_large'];
        this.gender = data['gender'];
        this.zipCode = data['zipCode'];
        const dob: Date = new Date(data['birthday']);
        this.isFloProMember = false;

        if (data['user_subscriptions'] &&
            data['user_subscriptions'].length > 0) {
            // The JWT token cookie might not be updated right away, in which case
            // we need to check the user's subscriptions
            data['user_subscriptions'].forEach((subscription: any) => {
                if (subscription.is_active) {
                    this.isFloProMember = true;
                }
            });
        }

        if (isValid(dob)) {
            // The birthday is provided in an ISO string and converting it to a Date
            // will adjust it's time based on the current timezone so we need to add
            // the utc offset minutes back on
            const utcOffset: number = (new Date()).getTimezoneOffset();
            const localTimezone: string = Intl.DateTimeFormat().resolvedOptions().timeZone;
            this.birthday = addMinutes(zonedTimeToUtc(dob, localTimezone), utcOffset);
        }

        return this;
    }
}
